// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blurb-module--wrapper--1r37d","wrapperFlipped":"Blurb-module--wrapper--flipped--1NjRa","image":"Blurb-module--image--2D20C","text":"Blurb-module--text--17Ruq"};